export default __webpack_public_path__ + "static/media/man_lang_hinten.2aac21e5.jpg";